import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ICareplan } from "@comunicare/comunicare-interfaces";

@Component({
  selector: "app-select-careplan-modal",
  templateUrl: "./select-careplan-modal.component.html",
  styleUrls: ["./select-careplan-modal.component.scss"],
})
export class SelectCareplanModalComponent {
  public selectedCareplan: ICareplan = this.data.careplans[0];
  constructor(
    public dialogRef: MatDialogRef<SelectCareplanModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { careplans: ICareplan[] }
  ) {}
}
